
import styles from "./ProjectCard.module.css";


export default function ProjectCard ({children, projectName}) {


    return (
        <div id={projectName} className={styles.projectCard}>
            {children}
        </div>
    )

    

}